import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonUIComponent, IconUIComponent } from '@shared-ui-kit';
import {
  injectLandingActions,
  injectLandingSeo,
  WebCardV1,
  WebEntityHomeSection,
  WebLoadsMap,
  WebParallaxBg,
  LANDING_VIDEOS,
} from '@feature-landing';

@Component({
  selector: 'fr8bot-drivers-page',
  imports: [
    IconUIComponent,
    ButtonUIComponent,
    WebParallaxBg,
    WebCardV1,
    WebLoadsMap,
    WebEntityHomeSection,
    TranslatePipe,
  ],
  templateUrl: './drivers-page.html',
  styleUrl: './drivers-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriversPage {
  protected readonly videos = LANDING_VIDEOS;

  constructor() {
    injectLandingSeo('drivers');
  }

  protected readonly landing = injectLandingActions();
}
